import { Box, Button, Typography } from "@mui/material";

const activeGalleryThumbBackground = "#000";
const inactiveGalleryThumbBorderColor = "#000";

function GalleryObservationThumb({ thumb, isSelected, onSelect }) {
  const thumbnailImageUrl = thumb.thumbnailUrl || thumb.url;

  return (
    <Button
      role="listitem"
      aria-label={thumb.label}
      aria-pressed={isSelected}
      variant="outlined"
      onClick={() => onSelect(thumb.key)}
      sx={{
        flex: "0 0 auto",
        flexDirection: "column",
        alignItems: "stretch",
        p: 0.75,
        minWidth: 96,
        maxWidth: 120,
        textTransform: "none",
        scrollSnapAlign: "start",
        color: isSelected ? "grey.300" : "text.primary",
        borderColor: isSelected ? "grey.100" : inactiveGalleryThumbBorderColor,
        backgroundColor: isSelected ? activeGalleryThumbBackground : undefined,
        "&:hover": {
          borderColor: isSelected ? "grey.400" : inactiveGalleryThumbBorderColor,
          backgroundColor: isSelected ? activeGalleryThumbBackground : undefined,
        },
      }}
    >
      {thumb.isPlaceholder ? (
        <Box
          sx={{
            width: "100%",
            height: 72,
            borderRadius: 0.5,
            mb: 0.5,
            backgroundColor: isSelected ? activeGalleryThumbBackground : "grey.700",
            border: `1px solid ${isSelected ? "grey.100" : inactiveGalleryThumbBorderColor}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="caption" color={isSelected ? "grey.400" : "grey.300"}>
            No image
          </Typography>
        </Box>
      ) : (
        <Box
          component="img"
          src={thumbnailImageUrl}
          alt=""
          loading="lazy"
          sx={{
            width: "100%",
            height: 72,
            objectFit: "cover",
            borderRadius: 0.5,
            mb: 0.5,
            backgroundColor: isSelected ? activeGalleryThumbBackground : "#fff",
            border: `1px solid ${isSelected ? "grey.100" : inactiveGalleryThumbBorderColor}`,
          }}
        />
      )}
      <Typography
        variant="caption"
        component="span"
        sx={{
          lineHeight: 1.2,
          textAlign: "left",
          color: isSelected ? "grey.100" : "text.primary",
        }}
      >
        {thumb.label}
      </Typography>
    </Button>
  );
}

export default GalleryObservationThumb;
